import React, { useState } from "react";
import { Card, CardHeader, Divider, CardContent, makeStyles, Button, CardActions, Select, MenuItem, Input, List, ListItem, Typography, ListItemText, Grid, CircularProgress } from "@material-ui/core";
import { formatQty } from "../Utils";
// import VisibilityIcon from '@material-ui/icons/Visibility';
// import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import PropTypes from "prop-types";
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { InventoryService } from "../Services/InventoryService";

const useStyles = makeStyles(theme => ({
    root: {
        margin: 5, 
        minHeight: 190,
    },
    icon: {
        padding: 2
    },
    content: {
        paddingTop: 0,
        paddingBottom: 0,
        minHeight: 200,
        paddingRight: 0,
        paddingLeft: 0,
    },
    itemDivider: {
        borderBottomColor: 'rgba(0,0,0,0.1)'
    },
    actions: {
        paddingTop: 0,
        justifyContent: 'flex-end'
    },
    arrowForwardIcon: {
        marginLeft: theme.spacing(1)
    },
    select: {
        marginTop: 8
    },
    griditem: {
        cursor: 'move'
    },
    loader: {
        marginTop: 40
    }
}));

const FCStock = ({ forwardedRef, ...props }) => {
    const classes = useStyles();
    const count = 5;
    const [loading, setLoading] = useState(false);
    const {report, className} = props;
    // const [isShown, setIsShown] = useState(false);
    const [type, setType] = React.useState('min');
    const [data, setData] = useState([]);

    // const changeVisibility = e => {
    //     if(report.visible === '1'){
    //         hideReport(report.id);
    //     } else {
    //         showReport(report.id);
    //     }
    // }

    //   { isShown && (
    //                     <BootstrapTooltip title={report.visible === '1' ? 'Click to Hide' : 'Click to Show' }>
    //                         <IconButton size="small" className={classes.icon} onClick={changeVisibility}>
    //                             {report.visible === '1' ? <VisibilityOffIcon /> : <VisibilityIcon /> }
    //                         </IconButton>
    //                     </BootstrapTooltip>
    //                 ) }
    React.useEffect(() => {
        setLoading(true);
        InventoryService.getFCStockList(type, count)
        .then(data => {
            setData(data);
            setLoading(false);
        })
        .catch(error => {
            console.log(error);
            setLoading(false);
        })
    }, [type]);

    return (
        <Grid item xl={4} lg={4} xs={12}>
            <Card 
                ref={forwardedRef}
                className={clsx(classes.root, className)}
                //onMouseEnter={() => setIsShown(true)}
                //onMouseLeave={() => setIsShown(false)}
                >
                <CardHeader 
                    title={report.name}
                    className={classes.griditem}
                    titleTypographyProps={{align: 'left'}}
                    action={
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={type}
                            onChange={(e) => setType(e.target.value)}
                            className={classes.select}
                            input={<Input  disableUnderline={true}/>}>
                            <MenuItem value={'min'}>By Min Stock</MenuItem>
                            <MenuItem value={'max'}>By Max Stock</MenuItem>
                        </Select>
                    }/>
                <Divider />
                <CardContent className={classes.content}>
                    {
                        loading ?
                            <div className={classes.loader}>
                                <CircularProgress/>
                            </div>
                        :
                        <List>
                            {data.map(data => (
                                <ListItem
                                    classes={{ divider: classes.itemDivider }}
                                    divider
                                    dense
                                    component={RouterLink}
                                    key={data.fc}
                                    to={`/inventory/report?fc=${data.fc}`}
                                >
                                    <ListItemText
                                        primary={data.fc}
                                        primaryTypographyProps={{ variant: 'subtitle2' }}
                                    />
                                    <Typography color="inherit">{formatQty(data.quantity)}</Typography>
                                </ListItem>
                            ))}
                        </List>
                    }
                </CardContent>
                <CardActions className={classes.actions}>
                    <Button
                        color="inherit"
                        component={RouterLink}
                        size="small"
                        to={`/inventory/report`}
                        variant="text"
                    >
                        See all
                    <ArrowForwardIcon className={classes.arrowForwardIcon} />
                    </Button>
                </CardActions>
            </Card>
        </Grid>
    );
};

FCStock.propTypes = {
    report: PropTypes.object.isRequired,
};

export default FCStock;